import { MainBanner, MainBannerProps } from '~/components/main-banner';

export function MsMainBanner({ cta, background, content, variant, fetchPriority, ...props }: MainBannerProps) {
  return <MainBanner background={background} content={content} cta={cta} fetchPriority={fetchPriority} variant={variant} {...props} />;
}
